import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {RenderTaskStatusWithIcon} from 'studies/typed/shared/ProcedureRunTableUtil';
import {UnitOperationStatusType} from 'studies/typed/shared/useMultiProcedureRunStudyProgress';
import * as Colors from 'ui-library/Colors';

export default function StatusCountPane({
  statuses,
  statusCounts,
  enabledStatusFilters,
  setFilters,
}: {
  statuses: Array<UnitOperationStatusType>;
  statusCounts: Map<UnitOperationStatusType, number>;
  enabledStatusFilters: Map<UnitOperationStatusType, boolean>;
  setFilters: (statuses: Array<UnitOperationStatusType>, isFilterSet: boolean) => void;
}): JSX.Element {
  const filterStatus = statuses.every((status) => enabledStatusFilters.get(status) ?? false);
  return (
    <div
      data-status-pane-id={statuses[0]}
      className={classNames(
        css(styles.roundedPane),
        css(styles.clickablePane),
        filterStatus ? css(styles.selectedPane) : null
      )}
      onClick={() => {
        setFilters(statuses, !filterStatus);
      }}
    >
      {statuses.length === 1 ? (
        <>
          <RenderTaskStatusWithIcon statusType={statuses[0]} />
          <div data-status-count-id={statuses[0]} className={css(styles.statusCount)}>
            {statusCounts.get(statuses[0]) ?? 0}
          </div>
        </>
      ) : (
        statuses.map((status) => (
          <div key={`status-count-${status}`} className={css(styles.miscStatusLine)}>
            <RenderTaskStatusWithIcon statusType={status} />
            <div data-status-count-id={status} className={css(styles.paneRight)}>
              {statusCounts.get(status) ?? 0}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  statusCount: {
    fontSize: 'x-large',
    paddingTop: 20,
  },
  roundedPane: {
    height: 'inherit',
    borderRadius: 4,
    border: `1px solid ${Colors.GRAY_LIGHT}`,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
  },
  clickablePane: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: Colors.GRAY_LIGHT,
    },
  },
  selectedPane: {
    borderColor: Colors.BLUE,
    backgroundColor: Colors.BLUE_POWDER_LIGHT,
  },
  paneRight: {
    paddingLeft: 10,
  },
  miscStatusLine: {
    display: 'flex',
    paddingBottom: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  statusText: {
    paddingLeft: 4,
  },
  paramsTableInCard: {
    width: '97%',
  },
});
